import { render, staticRenderFns } from "./RelatorioRupturaRoute.vue?vue&type=template&id=ecf8212c"
import script from "./RelatorioRupturaRoute.vue?vue&type=script&lang=js"
export * from "./RelatorioRupturaRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports